// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-acac1550]{color:#ed4014}.table .el-image[data-v-acac1550]{width:auto !important;height:30px !important}.table[data-v-acac1550] ::v-deepel-image__inner,.table .el-image__placeholder[data-v-acac1550],.table .el-image__error[data-v-acac1550]{width:auto !important}.info[data-v-acac1550]{width:82%}", ""]);
// Exports
module.exports = exports;
